import useEvent from '../useEvent.js';
import useDragPosition from './useDragPosition.js';

var getTouchEventPosition = function getTouchEventPosition(event) {
  var _event$touches$ = event.touches[0],
    pageX = _event$touches$.pageX,
    pageY = _event$touches$.pageY;
  return {
    horizontalChange: pageX,
    verticalChange: pageY
  };
};
var useTouchDrag = function useTouchDrag(target, onDrag) {
  var _useDragPosition = useDragPosition(getTouchEventPosition, onDrag),
    isDragging = _useDragPosition.isDragging,
    handleDragStart = _useDragPosition.handleDragStart,
    handleDragMove = _useDragPosition.handleDragMove,
    handleDragEnd = _useDragPosition.handleDragEnd;
  useEvent('touchstart', handleDragStart, target);
  useEvent('touchmove', handleDragMove, undefined, {
    passive: false
  });
  useEvent('touchend', handleDragEnd);
  return isDragging;
};

export { useTouchDrag as default };
//# sourceMappingURL=useTouchDrag.js.map
